import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <a href="#featured" className="group block overflow-hidden rounded-lg bg-background-100">
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-2 top-2 rounded-full px-2.5 py-0.5 text-xs font-medium text-background-50 ${
            comic.status === "连载" ? "bg-accent-500" : "bg-secondary-600"
          }`}
        >
          {comic.status}
        </span>
        <span className="absolute right-2 top-2 rounded-full bg-foreground-950/60 px-2 py-0.5 text-xs text-background-50 backdrop-blur-sm">
          <i className="ri-star-fill mr-0.5 text-secondary-400" aria-hidden="true"></i>
          {comic.rating}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-700">
          {comic.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-600">{comic.latestChapter}</p>
        <div className="mt-2 flex items-center justify-between">
          <span className="whitespace-nowrap rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
            {comic.categories[0]}
          </span>
          <span className="whitespace-nowrap text-xs text-foreground-500">
            <i className="ri-eye-line mr-1" aria-hidden="true"></i>
            {comic.reads}
          </span>
        </div>
      </div>
    </a>
  );
}